import { useSelector } from "react-redux";

const PaymentOnSite = () => {

  const { systemProfile } = useSelector(state => state.global)

  return (
    <div>
      <div
        className="w-full bg-gray-300 p-1.5 shadow-lg rounded-lg text-center relative p-2 space-y-2"
        style={{
          fontFamily: 'Nunito'
        }}
      >
        <div className="uppercase font-bold">
          Pembayaran di tempat
        </div>
        <div
          className="bg-blue-100 p-2 px-5 rounded-lg"
          style={{
            fontSize: '14px'
          }}
        >
          <ol className="text-left">
            <li className="p-0">
              Pembayaran dan verifikasi dilakukan hanya pada jam kerja
            </li>
            <li className="p-0">
              Silahkan datang ke tempat kami dengan alamat di bawah
            </li>
          </ol>
        </div>
      </div>
      <div
        className="space-y-5 p-5 pt-8 border border-gray-300 rounded-lg shadow-lg"
        style={{
          marginTop: '-15px',
          fontSize: '14px'
        }}
      >
        <p>
          {systemProfile.companyAddress}
        </p>
        <p>No. Telp : {systemProfile.companyPhone}</p>
      </div>

    </div>
  )
}

export default PaymentOnSite;